import React from 'react';
import { ArrowRightIcon, CheckIcon } from 'lucide-react';
import { Frame } from './Frame';
import { StackedIcon } from './StackedIcon';
import { services } from '../data/services';
export function Services() {
  return <section id="services" aria-labelledby="services-title" className="scroll-mt-[72px]" data-id="element-509" data-mp="1dsptwc6omshr">
      <Frame data-id="element-510" data-mp="18twh6lz7z5in">
        <div className="px-5 pb-16 pt-16 md:px-6 md:pb-24 md:pt-24" data-id="element-511" data-mp="18ufyq1kyjrw5">
          <div className="text-center" data-id="element-512" data-mp="13w4npnixfbcc">
            <h2 id="services-title" className="mx-auto max-w-[760px] font-display text-[36px] font-semibold leading-[1.05] tracking-[-0.04em] text-ink md:text-[52px]" data-id="element-513" data-mp="13x61w0v8odya">
              Technische Lösungen, passend zu Ihrer Aufgabe.
            </h2>
          </div>

          <ul className="mx-auto mt-12 grid max-w-[1120px] gap-4 md:mt-16 md:grid-cols-3 md:gap-5" data-id="element-514" data-mp="q6awwznv2gzz">
            {services.map(service => <li key={service.id} className="flex flex-col rounded-[12px] bg-white p-7 shadow-[0_0_0_1px_rgba(70,28,64,0.07),0_1px_2px_rgba(70,28,64,0.04),0_10px_28px_-12px_rgba(70,28,64,0.1)] md:p-8" data-id="element-515" data-mp="g5quvusip8gp">
                <StackedIcon shape={service.icon} className="h-10 w-14" data-id="element-516" data-mp="3b4hfhnpizopx" />
                <h3 className="mt-7 text-[21px] font-medium leading-snug tracking-[-0.02em] text-ink" data-id="element-517" data-mp="2xd2u5a85bbfp">{service.title}</h3>
                <p className="mt-2 text-[15px] leading-relaxed text-muted" data-id="element-518" data-mp="32b4dlw9hhcrp">{service.summary}</p>
                <ul className="mt-6 space-y-2.5 border-t border-line pt-6" data-id="element-519" data-mp="3q18fnz70x4gl">
                  {service.points.map(point => <li key={point} className="flex items-start gap-2.5 text-[14px] leading-snug text-ink/80" data-id="element-520" data-mp="3g29h59fz2p7b">
                      <CheckIcon className="mt-[2px] h-3.5 w-3.5 shrink-0 text-ink" strokeWidth={2.5} data-id="element-521" data-mp="3l13ys827e7pu" />
                      {point}
                    </li>)}
                </ul>
              </li>)}
          </ul>

          <div className="mx-auto mt-10 flex max-w-[1120px] flex-col items-center justify-between gap-4 rounded-[12px] bg-canvas px-7 py-6 text-center md:flex-row md:text-left" data-id="element-522" data-mp="29ns1kg0y8ncn">
            <div data-id="element-523" data-mp="1ljk1h46d0tme">
              <p className="text-[16px] font-medium text-ink" data-id="element-524" data-mp="1lj0uujm5trno">Nicht sicher, welche Leistung Sie benötigen?</p>
              <p className="mt-1 text-[14px] text-muted" data-id="element-525" data-mp="1gpxyy4twu64b">
                Senden Sie Ihre Unterlagen – ich schlage Ihnen den passenden Leistungsumfang vor.
              </p>
            </div>
            <a href="#contact" className="group inline-flex shrink-0 items-center gap-2 rounded-[8px] bg-ink px-5 py-3 text-[15px] font-medium text-white transition-colors duration-150 hover:bg-ink/85" data-id="element-526" data-mp="16v61r248pla2">
              Kostenloses Angebot erhalten
              <ArrowRightIcon className="h-4 w-4 transition-transform duration-150 ease-out group-hover:translate-x-0.5" data-id="element-527" data-mp="sv503kg5i9tj" />
            </a>
          </div>
        </div>
      </Frame>
    </section>;
}